import { ArtistInterface } from '../artist/Artist';
import { ImageInterface } from '../image/Image';
import { LocationInterface } from '../location/Location';
import { PublicState } from '../Api';
import { ImageGallery } from '../image/ImageGallery';

export enum EventType {
  PUBLIC = 'PUBLIC',
  PRIVATE = 'PRIVATE',
  ONLINE = 'ONLINE',
}

export interface EventListDto {
  id?: number;
  publicId?: string;
  created?: string;
  createdByEMail?: string;
  updated?: string;
  updatedByEMail?: string;
  url: string;
  title: string;
  description: string;
  locationTitle: string;
  onlineEvent: boolean;
  vibeEvent: boolean;
  image: ImageInterface;
  startDateTime: string;
}

export interface EventInterface {
  id?: number;
  publicId?: string;
  created?: string;
  createdByEMail?: string;
  updated?: string;
  updatedByEMail?: string;
  url?: string;
  title: string;
  description: string;
  facts: string;
  startDateTime: string;
  endDateTime: string;
  status?: PublicState;
  type: EventType;
  ticketUrl?: string;
  onlineEvent?: boolean;
  vibeEvent?: boolean;
  eventUrl?: string;
  location: LocationInterface;
  image?: ImageInterface;
  imageGallery?: ImageGallery;
  artists: ArtistInterface[];
  easyVereinEventId?: number;
}
